/** Converts number to CSS px unit, e.g. `1` will become `1px`. */
export function toPx(unit: number | string) {
  return `${unit}px`;
}
